module.exports = __webpack_public_path__ + "static/media/footer-messages.7c4f0c9f.png";